module.exports = __webpack_public_path__ + "img/proteina-leche.a8bd852d.png";